var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconQr = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    opacity: 0.48,
    transform: "translate(-46 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    opacity: 0,
    width: 24,
    height: 24,
    transform: "translate(46 -40)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "stroke:rgba(0,0,0,0)",
    d: "M2019-13945a1.923,1.923,0,0,1-2-2v-16a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v16a1.97,1.97,0,0,1-2,2c-.039.011-4.019.016-8,.016S2019.039-13944.989,2019-13945Zm0-2h16v-16h-16Zm12-2v-2h2v2Zm-10,0v-2h2v2Zm7-2v-3h3v3Zm-3,0v-2h2v2Zm-4-3v-7h7v7Zm8-1v-2h2v2Zm2-4v-2h2v2Z",
    transform: "translate(-1969 13927)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(52 -34)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconQr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-qr.ce802404.svg";
export { ForwardRef as ReactComponent };